module.exports = "span.badge{float:right;position:absolute;right:35px;top:15px}\n"